import { useMemo, useCallback } from "react"
import { Form, Input, Select, Button } from 'antd'
import BlockComplex from '@/components/BlockComplex'
import * as api from '@/api/workbench'
import { gztLyOptions } from '@/utils/options'
import ZtTag from '@/pages/Workbench/components/WorkList/components/ZtTag'

const Comp = () => {

  const handleApprove = useCallback(() => {
    window.openInnerPage('/xmk/xmgl/xmk/xmjsNew/kpglNew?jzzt=1', '开票管理')
  }, [])

  const columns = useMemo(() => {
    return [
      { title: '记账状态', width: 100, dataIndex: 'JZZT', ellipsis: true, render(text) {
        return <ZtTag text={text} />
      } },
      {
        title: '开票计划编号', 
        width: 150, 
        dataIndex: 'KPJH_DH',
        ellipsis: true,
      },
      { title: '来源', width: 100, dataIndex: 'LY', ellipsis: true },
      { title: '发票号码', width: 100, dataIndex: 'FPHM', ellipsis: true },
      { title: '付款方名称', width: 160, dataIndex: 'SKDW', ellipsis: true },
      { title: '开票金额', width: 100, dataIndex: 'KPJE', ellipsis: true },
      {
        title: '操作', 
        width: 60, 
        dataIndex: 'cz', 
        render() {
          return <Button type="link" onClick={handleApprove}>记账</Button>
        }
      }
    ]
  }, [handleApprove])

  return (
    <div className="">
      <BlockComplex
        columns={columns}
        rowKey="KPJH_DH"
        load={api.getCwsxDkpjz}
        searchForm={
          <>
            <Form.Item
              label="开票计划编号"
              name="kpjhbh"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
            <Form.Item
              label="来源"
              name="ly"
            >
              <Select placeholder="请选择" allowClear>
                {
                  gztLyOptions.map(item => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)
                }
              </Select>
            </Form.Item>
            <Form.Item
              label="付款方名称"
              name="fkfmc"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
            <Form.Item
              label="发票号码"
              name="fphm"
            >
              <Input placeholder="请输入" allowClear />
            </Form.Item>
          </>
        }
      />
    </div>
  )
}

export default Comp
